import styled from '@emotion/styled';

import { CardLayout } from '../CardLayout';

export const OnboardingLayoutContainer = styled.div`
  --onboarding-layout-gap: 3rem;

  display: grid;
  min-height: 100vh;
  grid-template-columns: 1fr 1fr;
  gap: var(--onboarding-layout-gap);
  padding: var(--onboarding-layout-gap);

  ${p => p.theme.breakpoints.down('md')} {
    --onboarding-layout-gap: 1.5rem;

    grid-template-columns: 1fr;
  }
`;

export const OnboardingLayoutContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 2rem;
`;

export const OnboardingLayoutContentCard = styled(CardLayout)`
  --card-layout-padding-horizontal: 3rem;
  --card-layout-padding-vertical: 3rem;
  --card-layout-border-radius: 1rem;
  --card-layout-shadow: 0 1rem 2rem rgba(0, 0, 0, 0.2);
  --card-layout-gap: 2rem;

  width: 100%;
  max-width: 40rem;

  ${p => p.theme.breakpoints.down('sm')} {
    --card-layout-shadow: none;
    --card-layout-padding-horizontal: 0;
    --card-layout-padding-vertical: 0;
    --card-layout-border-radius: 0;
    --card-layout-gap: 1.5rem;
  }
`;

export const OnboardingLayoutPoweredBy = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const OnboardingLayoutPoweredByImage = styled.img`
  height: 2rem;
`;

export const OnboardingLayoutSplashContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

export const OnboardingLayoutSplashImage = styled.img`
  height: 100%;
  max-height: calc(100% - (2 * var(--onboarding-layout-gap)));
  overflow: hidden;
  object-fit: contain;
`;
